import { HttpFactory } from './shared/factory/http-factory';
import { Routes } from '@angular/router';
import { TvshopComponent } from './tv-shop-component/tv-shop-component';
import { Environment } from './shared/environment/environment';
import { StompConfig } from '@stomp/ng2-stompjs';
import * as SockJS from 'sockjs-client';
import { PincodeServiceFactory } from './services/pincode/pincode-service-factory';
import { CacheLoader, CacheStaticLoader } from '@ngx-cache/core';
import { DeepLinkingComponent } from './deep-linking/deep-linking.component';
import { ChangeLogComponent } from './change-log/change-log.component';
var appRoutes = [
    { path: 'index.html', component: TvshopComponent, pathMatch: 'full' },
    { path: '', redirectTo: 'index.html', pathMatch: 'full' },
    { path: 'salesoffer:id', component: DeepLinkingComponent },
    { path: 'salesoffer', component: DeepLinkingComponent },
    { path: 'status/change-log', component: ChangeLogComponent }
];
var ɵ0 = function () {
    return new SockJS(Environment.environmentConfig().baseApiUrl + '/ocapi/notify/');
};
var stompConfig = {
    url: ɵ0,
    headers: {},
    heartbeat_in: 0,
    heartbeat_out: 20000,
    reconnect_delay: 5000,
    debug: true
};
export function cacheFactory() {
    return new CacheStaticLoader({
        key: 'NGX_CACHE',
        lifeSpan: {
            'expiry': Number.MAX_VALUE,
            'TTL': Number.MAX_VALUE // seconds
        }
    });
}
var ɵ1 = (cacheFactory), ɵ2 = HttpFactory.createTranslateHttpLoader, ɵ3 = PincodeServiceFactory.createPincodeService, ɵ4 = stompConfig;
var AppModule = /** @class */ (function () {
    function AppModule() {
    }
    return AppModule;
}());
export { AppModule };
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4 };
